import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_APPLICATIONS_SETTING_BY_ID } from './get-applications-setting-by-id.hook';
import { GET_APPLICATIONS_SETTING } from './get-applications-setting.hook';
import { GET_APPLICATIONS_EUA_SETTING } from './get-application-company-setting.hook';

export const UPDATE_APPLICATIONS_SETTINGS = gql`
  mutation updateApplicationsSetting($payload: UpdateApplicationsSettingInput!) {
    updateApplicationsSetting(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateApplicationsSetting = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [updateApplicationsSetting, { loading }] = useMutation(UPDATE_APPLICATIONS_SETTINGS, {
    onCompleted: data => {
      if (data?.updateApplicationsSetting?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('applications.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [
      GET_APPLICATIONS_SETTING_BY_ID,
      GET_APPLICATIONS_SETTING,
      GET_APPLICATIONS_EUA_SETTING,
    ],
  });

  return { updateApplicationsSetting, loading };
};
